import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import "./AdminDashboard.css"
import AddTransaction from './Components/AddTransaction'
import AddMember from './Components/AddMember'
import AddBook from './Components/AddBook';
import Profile from './Components/Profile';
import { AuthContext } from '../../../Context/AuthContext';
import ThemeStudio from './Components/ThemeStudio';
import GetMember from './Components/GetMember';
import Return from './Components/Return';

import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BookIcon from '@material-ui/icons/Book';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PaletteIcon from '@material-ui/icons/Palette';

function AdminDashboard() {
    const { dispatch, user } = useContext(AuthContext);
    const history = useHistory();
    const [active, setActive] = useState("profile")
    const [sidebar, setSidebar] = useState(false)

    /* Logout Function*/
    const logout = () => {
        // Clear user from localStorage
        localStorage.removeItem("user");

        // Update the auth context
        dispatch({ type: "LOGOUT" });

        // Redirect to home page
        history.push('/');
    }

    const setActiveAndClose = (section) => {
        setActive(section);
        setSidebar(false);
    };

    return (
        <div className="admin-dashboard">
            <div className="admin-dashboard__container">
                <button
                    className="admin-dashboard__sidebar-toggle"
                    onClick={() => setSidebar(!sidebar)}
                    aria-label="Toggle sidebar"
                >
                    {sidebar ? <CloseIcon /> : <MenuIcon />}
                </button>

                {/* Sidebar */}
                <aside className={`admin-dashboard__sidebar ${sidebar ? 'is-open' : ''}`}>
                    <div className="admin-dashboard__sidebar-header">
                        <LibraryBooksIcon className="admin-dashboard__logo-icon" />
                        <span className="admin-dashboard__logo-text">Library Prime</span>
                    </div>

                    <nav className="admin-dashboard__nav">
                        <button
                            className={`admin-dashboard__nav-item ${active === "profile" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("profile")}
                        >
                            <AccountCircleIcon className="admin-dashboard__nav-icon" />
                            <span>Profile</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "addbook" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("addbook")}
                        >
                            <BookIcon className="admin-dashboard__nav-icon" />
                            <span>Add Book</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "addtransaction" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("addtransaction")}
                        >
                            <ReceiptIcon className="admin-dashboard__nav-icon" />
                            <span>Add Transaction</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "getmember" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("getmember")}
                        >
                            <AccountBoxIcon className="admin-dashboard__nav-icon" />
                            <span>Get Member</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "addmember" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("addmember")}
                        >
                            <PersonAddIcon className="admin-dashboard__nav-icon" />
                            <span>Add Member</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "designstudio" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("designstudio")}
                        >
                            <PaletteIcon className="admin-dashboard__nav-icon" />
                            <span>Design Studio</span>
                        </button>
                        <button
                            className={`admin-dashboard__nav-item ${active === "returntransaction" ? "is-active" : ""}`}
                            onClick={() => setActiveAndClose("returntransaction")}
                        >
                            <AssignmentReturnIcon className="admin-dashboard__nav-icon" />
                            <span>Return</span>
                        </button>
                    </nav>

                    <button
                        className="admin-dashboard__logout"
                        onClick={logout}
                    >
                        <PowerSettingsNewIcon className="admin-dashboard__nav-icon" />
                        <span>Log Out</span>
                    </button>
                </aside>

                {/* Main Content */}
                <main className="admin-dashboard__main">
                    <div className="admin-dashboard__content">
                        <div className="admin-dashboard__section" style={active !== "profile" ? { display: 'none' } : {}}>
                            <Profile />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "addbook" ? { display: 'none' } : {}}>
                            <AddBook />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "addtransaction" ? { display: 'none' } : {}}>
                            <AddTransaction />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "addmember" ? { display: 'none' } : {}}>
                            <AddMember />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "getmember" ? { display: 'none' } : {}}>
                            <GetMember />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "designstudio" ? { display: 'none' } : {}}>
                            <ThemeStudio currentUser={user} />
                        </div>
                        <div className="admin-dashboard__section" style={active !== "returntransaction" ? { display: 'none' } : {}}>
                            <Return />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default AdminDashboard;
